import Nouislider from "nouislider-react";
import React, { Component } from "react";
import "nouislider/distribute/nouislider.css";

export default class AnimationMarkerPeriod extends Component {
  constructor(props) {
    super(props);

    this.state = {
      targetNouislider: 0,
      commentNumber: props.commentNumber,
    };
    this.sliderRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.commentNumber !== nextProps.commentNumber) {
      this.setState({ commentNumber: nextProps.commentNumber });
    }
  }

  isShowPeriodRangePresent() {
    const { showPeriodRange } = this.props;
    return Array.isArray(showPeriodRange) && showPeriodRange.length > 1
  }

  handleClickOpenNouislider = (event) => {
    const sliderBounds = this.sliderRef.current.getBoundingClientRect();
    const clickPosition = event.clientX - sliderBounds.left;
    const duration =
      this.props.player != undefined && this.props.player.state != null
        ? this.props.player.state.totalDuration
        : this.props.duration;
    const percentage = (clickPosition / sliderBounds.width) * duration * 1000;
    this.setState({
      targetNouislider: percentage,
    });
    this.props.updateIsOpenNouislider()
  };

  openFrameVideo = (render, handle, value, un, percent) => {
    if (this.isShowPeriodRangePresent()) return;

    const { isEmbedVideo, player } = this.props;
    if (!player) return;

    let seekTime = handle === 0 ? value[0] : value[1];
    if (isEmbedVideo) {
      player.pauseVideo();
      player.seekTo(seekTime / 1000, true)
    } else {
      player?.pause();
      player.seek(seekTime / 1000);
    }

    // Call onMarkerPeriodChanged callback if provided (for CompareVersion sync)
    if (this.props.onMarkerPeriodChanged) {
      this.props.onMarkerPeriodChanged(seekTime / 1000);
    }
  }

  handelUpdateNouislider = (render, handle, value, un, percent) => {
    if (this.isShowPeriodRangePresent()) return;

    this.openFrameVideo(render, handle, value, un, percent)

    if (value[0] !== value[1]) {
      this.props.openPeriodCommentBox([value[0] / 1000, value[1] / 1000]);
    }
  };

  showTimeOnHover = (event, duration) => {
    const overX = 1000;
    const sliderBounds = this.sliderRef.current.getBoundingClientRect();
    const clickPosition = event.clientX - sliderBounds.left;
    const percentage = (clickPosition / sliderBounds.width) * duration * overX;
    const positionShowTimeLine = 1 - (clickPosition / sliderBounds.width)
    const parentId = this.props.commentPeriodContainer || "comment-period-container-first";

    $(`#${parentId} #noui-parent`).css('transform', 'translate(-' + (positionShowTimeLine * overX) + '%, 0)')
    $(`#${parentId} #show-time-line`).removeClass('d-none').html(moment.utc(percentage).format("HH:mm:ss.S"))
  }

  render() {
    const { player, isOpenNouislider, showPeriodRange } = this.props;
    const { targetNouislider, commentNumber } = this.state;
    const duration =
      player != undefined && player.state != null
        ? player.state.totalDuration
        : this.props.duration;

    return (
      <div className="comment-period-container" id={this.props.commentPeriodContainer || "comment-period-container-first"}>
        <div style={{ display: "flex" }}>
          <p className="title">範囲指定</p>

          {duration > 0 && (this.isShowPeriodRangePresent() || isOpenNouislider) ? (
            <div className="animation-marker-period noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr noUi-show-period"
              onMouseMove={e => {this.showTimeOnHover(e, duration)}}
              ref={this.sliderRef}
            >
              <div className="noUi-origin" id="noui-parent" style={{ transform: `translate(-10px, 0)` }}>
                <div className="noUi-handle noUi-handle-lower hidden-noui">
                  <div className="noUi-tooltip d-none" id="show-time-line"></div>
                </div>
              </div>
              <Nouislider
                range={{ min: 0, max: duration * 1000 }}
                start={this.isShowPeriodRangePresent() ? showPeriodRange : [targetNouislider, targetNouislider]}
                step={1}
                connect
                className="animation-marker-period"
                ref={this.sliderRef}
                onUpdate={this.openFrameVideo}
                onChange={this.handelUpdateNouislider}
                disabled={this.isShowPeriodRangePresent()}
                tooltips = {[
                  {
                    to: function(value) {
                      return moment.utc(value).format("HH:mm:ss.S");
                    },
                  },
                  {
                    to: function(value) {
                      return moment.utc(value).format("HH:mm:ss.S");
                    }
                  }
                ]}
              />
            </div>
          ) : (
            <div
              className="animation-marker-period noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr noUi-show-period"
              onClick={this.handleClickOpenNouislider}
              ref={this.sliderRef}
            >
              <div className="noUi-base">
                <div className="noUi-connects" onMouseMove={e => {this.showTimeOnHover(e, duration)}}>
                </div>
                <div className="noUi-origin" id="noui-parent" style={{ transform: `translate(-10px, 0)` }}>
                  <div className="noUi-handle noUi-handle-lower hidden-noui">
                    <div className="noUi-tooltip" id="show-time-line"></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="comment-period-note">
          {
            this.isShowPeriodRangePresent() ? (
              <React.Fragment>
                <span className="comment-number">{this.state.commentNumber}</span>
                <span>で指定した範囲です。</span>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <span>クリック後</span>
                <div className="marker-circle"></div>
                <span>スクロールで範囲指定</span>
              </React.Fragment>
            )
          }
        </div>
      </div>
    );
  }
}
